import * as Backbone from "backbone";
import {BaseCollection} from "./_BaseCollection";

interface ActionPacketCollectionOptions {
    installId: number
}

export class ActionPacketCollection extends BaseCollection<Backbone.Model> {

    installId: number;

    url = () => {
        return window.location.origin + '/api/v1/action_packets/' + this.installId;
    };

    constructor(initialModels: Object[] | any[], options: ActionPacketCollectionOptions) {
        super(initialModels, options);
        this.installId = options.installId;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/ActionPackets.ts